import {$,Marionette,Foundation} from '../../../vendor';
import InboomaBaseView from '../InboomaBaseView';

import FacilitiesSortTabsTpl from '../../templates/facilities/FacilitiesSortTabsTpl.html';

export default InboomaBaseView.extend({

  template : FacilitiesSortTabsTpl,
  el : '#inb-c-main-sort-nav',

  ui : {
    button : 'li.tabs-title:not(.is-active)'
  },

  events : {
    'click @ui.button' : '_changeCollectionSort',
  },

  onRender : function() {

    // https://foundation.zurb.com/sites/docs/sticky.html
    Foundation.Sticky.defaults.marginTop = 0;
    const sticky = new Foundation.Sticky(this.$el);

  },

  _changeCollectionSort : function(el) {
    //TODO: enable sorting
    //disabled as of now
    return false;

    // el = $(el.currentTarget);
    // el.parent().find('.is-active').removeClass('is-active');
    // el.addClass('is-active');
    // this.collection.setSort(el.attr('data-inb-val'));
    //
    // return false;
    
  }
});